module.exports = __webpack_public_path__ + "static/media/imageForNotification2.cf009122.svg";